
    const config = {
      api_url: 'https://ccc.wangwanglive.com/apinew/',
      login_url: 'https://www.flw.ph/plugin.php?id=zimu_fenlei&model=apiloginccc',
    };

    export default config;



// WEBPACK FOOTER //
// ./src/config/index.js